import Index from './Index';
import Create from './Create';
import Update from './Update';
import Show from './Show';
import {
  Switch,
  Route,
  useRouteMatch,
} from "react-router-dom";

let Partners = (props) => {
  let { path } = useRouteMatch();
  const theme = props.theme;

  return <>
    <Switch>
      <Route exact path={`${path}`}>
        <Index theme={theme} setShowMenu={props.setShowMenu} />
      </Route>
      <Route exact path={`${path}/cadastro`}>
        <Create theme={theme} />
      </Route>
      <Route exact path={`${path}/detalhe/:partner_seller_id`}>
        <Show theme={theme} />
      </Route>
      <Route exact path={`${path}/editar/:partner_seller_id`}>
        <Update theme={theme} />
      </Route>
    </Switch>
  </>
}

export default Partners;
